module.exports = __webpack_public_path__ + "static/media/minus-green.cf8711eb.svg";